import { upsellsTypes } from './upsellsTypes'

export const upsellsList = [
	{
		type: upsellsTypes.UPSELL1,
		isSelected: false,
	},
	{
		type: upsellsTypes.UPSELL2,
		isSelected: false,
	},
	{
		type: upsellsTypes.UPSELL3,
		isSelected: false,
	},
	{
		type: upsellsTypes.UPSELL4,
		isSelected: false,
	},
]
